import LeftNavigationLink from './LeftNavigationLink';

export default LeftNavigationLink;
